// Anonymous session management for non-logged-in users

const ANONYMOUS_SESSION_KEY = 'maxel_anonymous_session_id';

/**
 * Generate a UUID using browser's crypto API
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Get or generate an anonymous session ID
 * Persists across browser sessions until manually cleared
 */
export function getAnonymousSessionId(): string {
  let sessionId = localStorage.getItem(ANONYMOUS_SESSION_KEY);
  
  if (!sessionId) {
    sessionId = `anon_${generateUUID()}`;
    localStorage.setItem(ANONYMOUS_SESSION_KEY, sessionId);
  }
  
  return sessionId;
}

/**
 * Clear the anonymous session (e.g., when user logs in)
 */
export function clearAnonymousSession(): void {
  localStorage.removeItem(ANONYMOUS_SESSION_KEY);
}

/**
 * Check if current user is anonymous (not logged in)
 */
export function isAnonymousUser(currentUser: any): boolean {
  return !currentUser;
} 